import { logger } from '../logger'
import { EventSenderPlugin } from './plugins'
import { ClarityPlugin } from './plugins/Clarity'
import { DataDogLoggerPlugin } from './plugins/DataDogLogger'
import { GoogleAnalyticsPlugin } from './plugins/GoogleAnalytics'
import { EventMetadata, SendEventData } from './types'

export class EventSenderManager {
  private plugins: EventSenderPlugin[] = []
  private metadata: EventMetadata = {}

  init() {
    this.plugins.forEach((plugin) => {
      try {
        plugin.init?.()
      } catch (error) {
        logger.error(`Error initializing plugin ${plugin.name}:`, error)
      }
    })
  }

  addPlugin(plugin: EventSenderPlugin) {
    if (!this.plugins.some((p) => p.name === plugin.name)) {
      this.plugins.push(plugin)
    }
  }

  removePlugin(pluginName: string) {
    this.plugins = this.plugins.filter((plugin) => plugin.name !== pluginName)
  }

  sendEvent(event: SendEventData) {
    this.plugins.forEach((plugin) => {
      try {
        plugin.sendEvent(event)
      } catch (error) {
        logger.error(`Error sending event with plugin ${plugin.name}:`, error)
      }
    })
  }

  updateMetadata(metadata: EventMetadata) {
    this.metadata = { ...this.metadata, ...metadata }
    this.plugins.forEach((plugin) => {
      try {
        plugin.updateMetadata?.(this.metadata)
      } catch (error) {
        logger.error(`Error updating metadata in plugin ${plugin.name}:`, error)
      }
    })
  }
}

const eventSenderManager = new EventSenderManager()

eventSenderManager.addPlugin(new DataDogLoggerPlugin())
eventSenderManager.addPlugin(new ClarityPlugin())
eventSenderManager.addPlugin(new GoogleAnalyticsPlugin())

eventSenderManager.init()

export { eventSenderManager }
